@if (users === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Calculating...
	</div>
}
@if (users) {
	<table class="log compact">
		<thead>
			<tr>
				<th></th>
				<th colspan="3" class="text-center">Logins over last:</th>
			</tr>
			<tr>
				<th>User</th>
				<th><a (click)="SortBy('day')" href="javascript:void(0)">Day</a></th>
				<th><a (click)="SortBy('month')" href="javascript:void(0)">Month</a></th>
				<th><a (click)="SortBy('semi')" href="javascript:void(0)">6 Months</a></th>
			</tr>
		</thead>
		@for (user of users; track user) {
			<tbody>
				<tr>
					<td>{{user.email}}</td>
					<td>{{user.day}}</td>
					<td>{{user.month}}</td>
					<td>{{user.semi}}</td>
				</tr>
			</tbody>
		}
	</table>
}